export const defaultDraft = {
  keyword: '',
  status: '',
  source: '',
  per_page: 15,
  sort: 'created_at_desc'
};

export const parseSort = (sortValue = defaultDraft.sort) => {
  const chunks = String(sortValue || defaultDraft.sort).split('_');
  const sort_order = chunks.pop() || 'desc';
  const sort_by = chunks.join('_') || 'created_at';
  return { sort_by, sort_order };
};

export const toParams = (draft = defaultDraft, page = 1) => {
  const { sort, per_page, ...rest } = draft;
  const numericPerPage = Number(per_page);
  const numericPage = Number(page);

  return {
    ...rest,
    ...parseSort(sort),
    per_page: Number.isFinite(numericPerPage) && numericPerPage > 0
      ? numericPerPage
      : defaultDraft.per_page,
    page: Number.isFinite(numericPage) && numericPage > 0 ? numericPage : 1
  };
};

export const toQuery = params => Object.keys(params || {})
  .filter(key => params[key] !== '' && params[key] !== null && params[key] !== undefined)
  .reduce((query, key) => ({ ...query, [key]: params[key] }), {});
